import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const token = localStorage.getItem("accessToken");
const API_BASE_URL = process.env.REACT_APP_BE_BASE_URL;

const GlobalTracker = () => {
  const location = useLocation(); // React Router Hook to detect route changes

  useEffect(() => {
    console.log("-----GLOBAL TRACKER-------");

    const startTime = performance.now(); // Time when the user lands on the page
    console.log("startTime: ", startTime);

    // Track Page View when the component mounts
    const trackPageView = async () => {
      const endTime = performance.now(); // Time when the user leaves the page
      console.log("endTime: ", endTime);

      const timeSpent = (endTime - startTime) / 1000; // Time spent in seconds

      try {
        const fetchData = await fetch(`${API_BASE_URL}/tracking/pageView`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-type": "application/json",
          },
          body: JSON.stringify({ url: location.pathname, timeSpent }),
        });

        const data = await fetchData.json();
        console.log("Tracking data sent:", data);
      } catch (error) {
        console.error("Error tracking page view:", error);
      }
    };

    // Trigger tracking when the user navigates away or the page is about to unload
    window.addEventListener("beforeunload", trackPageView);

    return () => {
      // Clean up the event listener when the component unmounts
      window.removeEventListener("beforeunload", trackPageView);
    };
  }, [location.pathname]);

  return null; // This component does not render anything
};

export default GlobalTracker;
